export const SET_FIRM_STRUCTURES = 'SET_FIRM_STRUCTURES';
export const SET_STRUCTURES = 'SET_STRUCTURES';
export const SET_SHARED_FILES = 'SET_SHARED_FILES';
